import { HTTP_METHODS } from '@studio/constants/axios';
import { CENTRAL_API_V1 } from '@studio/constants/env-variables';
import type { Users } from '@studio/types';

export const id = {
  [HTTP_METHODS.GET]: {
    url: `${CENTRAL_API_V1}/users/@id`,
    response: {} as Users.Get.V1.User,
    params: {} as { id: string },
    method: HTTP_METHODS.GET,
  },
};
